export { HomePageBannerSection } from "./HomePageBannerSection";
export { HomePageContentSection } from "./HomePageContentSection";
export { HomePageReasonsSection } from "./HomePageReasonsSection";
export { HomePageServicesSection } from "./HomePageServicesSection";
